import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'
import storeInit from 'initializations/pages/CargoPage'

export class Main extends AbstractView {
  constructor(domElementId) {
    return super(domElementId);
  }

  init() {
    storeInit.init("charter")

    const CargoPage = () => import(/* webpackChunkName: "cargo-page" */ 'containers/Pages/CharterCargo/CharterPage')

    new Vue({
      el: "#" + this.elemId,
      store,
      render: h => h(CargoPage)
    })
  }
}
